export interface InvoiceSocialProfile {
  instagram?: string
  facebook?: string
  tiktok?: string
  whatsapp?: string
  website?: string
  otherLabel?: string
  otherValue?: string
}

/** Optional invoice-only overrides (social links). Company/outlet/address come from Firestore place/company. */
export interface InvoiceProfileV1 {
  version: 1
  social?: InvoiceSocialProfile
}

export function defaultInvoiceProfile(): InvoiceProfileV1 {
  return { version: 1 }
}

function mergeSocial(raw: unknown): InvoiceSocialProfile | undefined {
  if (!raw || typeof raw !== 'object') return undefined
  const s = raw as Partial<InvoiceSocialProfile>
  const social: InvoiceSocialProfile = {}
  if (typeof s.instagram === 'string' && s.instagram.trim()) social.instagram = s.instagram.trim()
  if (typeof s.facebook === 'string' && s.facebook.trim()) social.facebook = s.facebook.trim()
  if (typeof s.tiktok === 'string' && s.tiktok.trim()) social.tiktok = s.tiktok.trim()
  if (typeof s.whatsapp === 'string' && s.whatsapp.trim()) social.whatsapp = s.whatsapp.trim()
  if (typeof s.website === 'string' && s.website.trim()) social.website = s.website.trim()
  if (typeof s.otherLabel === 'string' && s.otherLabel.trim()) social.otherLabel = s.otherLabel.trim()
  if (typeof s.otherValue === 'string' && s.otherValue.trim()) social.otherValue = s.otherValue.trim()
  return Object.keys(social).length ? social : undefined
}

export function mergeInvoiceProfile(raw: unknown): InvoiceProfileV1 {
  const def = defaultInvoiceProfile()
  if (!raw || typeof raw !== 'object') return def
  const r = raw as Partial<InvoiceProfileV1> & {
    companyName?: string
    outletName?: string
    address?: string
    logoUrl?: string
  }
  if (r.version !== 1) return def
  const social = mergeSocial(r.social)
  return social ? { version: 1, social } : { version: 1 }
}
